import React from 'react'
import classNames from 'classnames'
import { bool, func } from 'prop-types'
import { useTranslation } from 'react-i18next'
import Icon from 'components/uiElements/Icon'
import * as modes from 'models/ui/constants'
import { productsDataType, sidepanelTabsType } from 'models/propTypes'

require('./SidepanelMenu.scss')

const SidepanelMenu = ({ setMode, isAdmin, addedToRoomItems, isOpen, open, hasFavoritesList, selectedTabs }) => {
    const { t } = useTranslation()

    const { isSwapSelected, isBrowseSelected, isMyListSelected, isFavoritesSelected, isDebugSelected, isRateSelected } =
        selectedTabs

    const hasMyItems = !!addedToRoomItems.length

    const openSidepanel = (sidepanelMode) => {
        if (!isOpen) {
            open()
        }
        setMode(sidepanelMode)
    }
    return (
        <div className="SidepanelMenu" role="tablist" aria-label="Side panel menu">
            <button
                className={classNames('menuItem products', { selected: isBrowseSelected })}
                onClick={() => openSidepanel(modes.DESIGN_SIDEPANEL_MODE_PRODUCT_BROWSE)}
                data-testid="sidepanel-menu-products"
                key="products"
                id="sidepanel-menu-products"
                role="tab"
                aria-selected={isBrowseSelected ? 'true' : 'false'}
                aria-controls="sidepanel-body-products"
            >
                <div className="menuText">
                    <Icon code="plus" />
                    {isBrowseSelected && <div>{t('design.add')}</div>}
                </div>

                <div className="selectedBorder" />
            </button>
            <button
                className={classNames('menuItem myItems', { selected: isSwapSelected })}
                onClick={() => openSidepanel(modes.DESIGN_SIDEPANEL_MODE_SWAP_BROWSE)}
                key="swapItems"
                data-testid="sidepanel-menu-swap-items"
                id="sidepanel-menu-swap-items"
                role="tab"
                aria-selected={isSwapSelected ? 'true' : 'false'}
                aria-controls="sidepanel-body-swap"
            >
                <div className="menuText">
                    <Icon code="informationCircle" />
                    {isSwapSelected && <div>{t('design.product options')}</div>}
                </div>
                <div className="selectedBorder" />
            </button>
            {hasMyItems ? (
                <button
                    className={classNames('menuItem myItems', { selected: isMyListSelected })}
                    onClick={() => openSidepanel(modes.DESIGN_SIDEPANEL_MODE_MYITEMS_BROWSE)}
                    key="myItems"
                    data-testid="sidepanel-menu-my-items"
                    id="sidepanel-menu-my-items"
                    role="tab"
                    aria-selected={isSwapSelected ? 'true' : 'false'}
                    aria-controls="sidepanel-body-my-items"
                >
                    <div className="menuText">
                        <Icon code="shopping_list" svg />
                        {isMyListSelected && <div>{t('design.my list')}</div>}
                    </div>
                    <div className="selectedBorder" />
                </button>
            ) : null}
            {hasFavoritesList ? (
                <button
                    className={classNames('menuItem myItems', { selected: isFavoritesSelected })}
                    onClick={() => openSidepanel(modes.DESIGN_SIDEPANEL_MODE_FAVORITES_BROWSE)}
                    key="favorites"
                    data-testid="sidepanel-menu-favorites"
                    id="sidepanel-menu-favorites"
                    role="tab"
                    aria-selected={isFavoritesSelected ? 'true' : 'false'}
                    aria-controls="sidepanel-body-favorites"
                >
                    <div className="menuText">
                        <Icon code="favorite" svg />
                        {isFavoritesSelected && <div>{t('design.favorites')}</div>}
                    </div>
                    <div className="selectedBorder" />
                </button>
            ) : null}
            {isAdmin ? (
                <>
                    <button
                        className={classNames('menuItem debug', { selected: isDebugSelected })}
                        onClick={() => openSidepanel(modes.DESIGN_SIDEPANEL_MODE_DEBUG)}
                        key="debug"
                        data-testid="sidepanel-menu-debug"
                        id="sidepanel-menu-debug"
                        role="tab"
                        aria-selected={isDebugSelected ? 'true' : 'false'}
                        aria-controls="sidepanel-body-debug"
                    >
                        <div className="menuText">
                            <Icon code="gear" />
                        </div>

                        <div className="selectedBorder" />
                    </button>
                    <button
                        className={classNames('menuItem rate', { selected: isRateSelected })}
                        onClick={() => openSidepanel(modes.DESIGN_SIDEPANEL_MODE_RATE)}
                        key="rate"
                        data-testid="sidepanel-menu-rate"
                        id="sidepanel-menu-rate"
                        role="tab"
                        aria-selected={isRateSelected ? 'true' : 'false'}
                        aria-controls="sidepanel-body-rate"
                    >
                        <div className="menuText">
                            <Icon code="starFilled" />
                        </div>

                        <div className="selectedBorder" />
                    </button>
                </>
            ) : null}
        </div>
    )
}

SidepanelMenu.propTypes = {
    setMode: func.isRequired,
    isAdmin: bool.isRequired,
    isOpen: bool.isRequired,
    addedToRoomItems: productsDataType.isRequired,
    open: func.isRequired,
    hasFavoritesList: bool.isRequired,
    selectedTabs: sidepanelTabsType.isRequired,
}

export default SidepanelMenu
